import { IOperon } from 'stores/models/LacOperon';

export const Colors = {
  Blue: '#048ba8',
  Green: '#83e377',
  Orange: '#fe9000',
  Transparent: 'transparent',
  Water: '#f3f3f3',
  Yellow: '#ffdd4a',
};

export const selectorFromDragAndDropType = (model: IOperon) =>
  model.info.type.replace('application/x.', '');
